import { render, staticRenderFns } from "./AllBankruptCase.vue?vue&type=template&id=2e4aa00c&scoped=true&"
import script from "./AllBankruptCase.vue?vue&type=script&lang=js&"
export * from "./AllBankruptCase.vue?vue&type=script&lang=js&"
import style0 from "./AllBankruptCase.vue?vue&type=style&index=0&id=2e4aa00c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4aa00c",
  null
  
)

export default component.exports